<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="w-full flex cpd-provider-form__shell">
      <v-card class="mx-auto w-full" flat max-height="auto" max-width="1000">
        <div class="flex flex-wrap cpd-provider-form__grid">
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider Name</label
            >
            <validation-provider
                v-slot="{ errors }"
                :rules="{
                required: true,
                regex: '^[A-Za-z0-9][A-Za-z0-9 ]*$',
              }"
            >
              <input
                  id="trainingCenterName"
                  v-model="formValues.trainingCenterName"
                  :disabled="disable"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="CPD Provider name"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.region_id"
                  :clearable="clearable"
                  :disabled="disable"
                  :elevation="1"
                  :items="REGIONS"
                  :loading="regionLoading"
                  :searchable="searchable"
                  dense
                  item-text="name"
                  item-value="id"
                  label="regions"
                  solo
                  @change="regionOnChange($event)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Zone</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
            <v-select
                v-model="formValues.zone_id"
                :clearable="clearable"
                :disabled="disable"
                :elevation="1"
                :items="FILTERED_ZONES"
                :loading="zoneLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="zones"
                solo
                @change="zoneOnChange($event)"
            ></v-select>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Woreda</label
            >
          <v-select
                v-model="formValues.woreda_id"
                :clearable="clearable"
                :disabled="disable"
                :elevation="1"
                :items="FILTERED_WOREDAS"
                :loading="woredaLoading"
                :searchable="searchable"
                dense
                item-text="name"
                item-value="id"
                label="woredas"
                solo
            ></v-select>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Institution Email Address</label
            >
            <validation-provider v-slot="{ errors }"
                                 :rules="{
                            email: true,
                            required: true}">
              <input
                  id="institutionEmail"
                  v-model="formValues.institutionEmailAddress"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="Cpd provider's email address"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Institution Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="{
                required: true,
                institution_phone_regex: true,
              }"
            >
              <input
                  id="phone number"
                  v-model="formValues.institutionPhoneNumber"
                  inputmode="numeric"
                  maxlength="13"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="+2511xxxxxxx or +2519xxxxxxx"
                  type="tel"
                  @input="onInstitutionPhoneInput('institutionPhoneNumber', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >
              P.O.BOX</label
            >
            <validation-provider v-slot="{ errors }">
              <input
                  id="pobox"
                  v-model="formValues.pobox"
                  :disabled="disable"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="institution pobox"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Name of Coordinator</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="coordinatorName"
                  v-model="formValues.coordinatorName"
                  :disabled="disable"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="co-ordinator name"
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Coordinator Email Address</label
            >
              <validation-provider v-slot="{ errors }"
                                   :rules="{
                            email: true,
                            required: true}">
              <input
                  id="coordinatorEmail"
                  v-model="formValues.coordinatorEmailAddress"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="Coordinator's email address"
                  type="email"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Coordinator Phone Number</label
            >
            <validation-provider
                v-slot="{ errors }"
                mode="eager"
                :rules="{
                phone_regex: '^\\+251[97]\\d{8}$',
                required: true,
              }"
            >
              <input
                  id="coordinatorPhoneNumber"
                  v-model="formValues.coordinatorPhoneNumber"
                  :disabled="disable"
                  inputmode="numeric"
                  maxlength="13"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  placeholder="+2519xxxxxxx"
                  type="tel"
                  @input="onPhoneInput('coordinatorPhoneNumber', $event.target.value, true)"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Accredited By:</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-autocomplete
                  v-model="formValues.accreditedById"
                  :clearable="clearable"
                  :disabled="Boolean(formValues.accreditedById) || disable"
                  :elevation="1"
                  :items="ACCREDITED_BY"
                  :loading="accreditorsLoading"
                  :searchable="searchable"
                  dense
                  hint="search for accrediator"
                  item-text="accreditorName"
                  item-value="id"
                  label="accreditors"
                  persistent-hint
                  solo
              ></v-autocomplete>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>

            <br/>
          </div>

          <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Date of Accreditation:
            </label>
            <validation-provider v-slot="{ errors }" rules="required">
              <v-menu
                  ref="menu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formValues.accreditationDate"
                      :disabled="disable"
                      label="accreditation date"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    ref="accreditationDate"
                    v-model="formValues.accreditationDate"
                    :max="date"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Ownership</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <div class="cpd-provider-form__radio-group">
                <label class="cpd-provider-form__radio">
                  <input
                      id="public"
                      v-model="formValues.cpdProviderOwnership"
                      :disabled="disable"
                      type="radio"
                      value="Public"
                  />
                  <span>Public</span>
                </label>
                <label class="cpd-provider-form__radio">
                  <input
                      id="private"
                      v-model="formValues.cpdProviderOwnership"
                      :disabled="disable"
                      type="radio"
                      value="Private"
                  />
                  <span>Private</span>
                </label>
                <label class="cpd-provider-form__radio">
                  <input
                      id="associations"
                      v-model="formValues.cpdProviderOwnership"
                      :disabled="disable"
                      type="radio"
                      value="Associations"
                  />
                  <span>Associations</span>
                </label>
                <label class="cpd-provider-form__radio">
                  <input
                      id="other"
                      v-model="formValues.cpdProviderOwnership"
                      :disabled="disable"
                      type="radio"
                      value="Other"
                  />
                  <span>Other</span>
                </label>
              </div>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
            <br/>
          </div>
          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Status</label
            >
            <validation-provider v-slot="{ errors }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-switch
                      v-model="formValues.isActive"
                      :disabled="disable"
                      color="green"
                      hide-details
                      v-on="on"
                  ></v-switch>
                </template>
                <span>{{
                  formValues.isActive == true ? "Active" : "Not Active"
                }}</span>
              </v-tooltip>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
            </validation-provider>
          </div>

          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Assessment Checklist</label
            >
            <validation-provider v-slot="{ errors }" :rules="formValues?.checklist ? '' : 'required'">
              <v-file-input
                  v-model="checklist"
                  name="checklist"
                  label="Assessment Checklist"
                  counter
                  show-size
                  @change="handleChecklistChange"
              ></v-file-input>
              <div v-if="checklistPreviewUrl" class="cpd-provider-form__preview">
                <div class="cpd-provider-form__preview-actions">
                  <v-btn
                      class="cpd-provider-form__download"
                      small
                      text
                      @click.prevent="openChecklistPreview"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Preview
                  </v-btn>
                </div>
                <iframe
                    class="cpd-provider-form__preview-frame"
                    :src="checklistPreviewUrl"
                    title="Assessment checklist preview"
                ></iframe>
              </div>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/4 px-3 mb-6 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Logo</label>
            <validation-provider v-slot="{ errors }"  name="Logo Image"
                                 :rules="{
                                          max_size: 2048,
                                          image: true,
                                        }">
              <v-file-input
                  v-model="logoImage"
                  counter
                  label="File input logo"
                  name="logoImage"
                  show-size
                  accept="image/*"
                  @change="handleAssetChange($event, 'logo')"
            ></v-file-input>
              <v-img
                  :src="assetPreviews.logo"
                  contain
                  max-height="300"
                  max-width="319"
              ></v-img>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/4 px-3 mb-6 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Stamp</label
            ><validation-provider v-slot="{ errors }"  name="Logo Image"
                                  :rules="{
                                          max_size: 2048,
                                          image: true,
                                        }">
            <v-file-input
                v-model="stampImage"
                counter
                label="File input stamp"
                name="stampImage"
                show-size
                accept="image/*"
                @change="handleAssetChange($event, 'stamp')"
            ></v-file-input>

            <v-img
                :src="assetPreviews.stamp"
                contain
                max-height="300"
                max-width="319"
            ></v-img>
            <span class="text-gray-600 text-xs italic text-red-700">{{
                errors[0]
              }}</span>
          </validation-provider>
          </div>
          <div class="w-full md:w-1/4 px-3 mb-6 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Signature 1</label
            >
            <validation-provider v-slot="{ errors }"  name="Logo Image"
                                 :rules="{
                                          max_size: 2048,
                                          image: true,
                                        }">
            <v-file-input
                v-model="signature1Image"
                counter
                label="File input signature 1"
                name="signature1Image"
                show-size
                accept="image/*"
                @change="handleAssetChange($event, 'signature1')"
            ></v-file-input>

            <v-img
                :src="assetPreviews.signature1"
                contain
                max-height="300"
                max-width="319"
            ></v-img>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full md:w-1/4 px-3 mb-6 md:mb-0">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >CPD Provider's Signature 2</label
            >
            <validation-provider v-slot="{ errors }"  name="Logo Image"
                                 :rules="{
                                          max_size: 2048,
                                          image: true,
                                        }">
            <v-file-input
                v-model="signature2Image"
                counter
                label="File input signature 2"
                name="signature2Image"
                show-size
                accept="image/*"
                @change="handleAssetChange($event, 'signature2')"
            ></v-file-input>

            <v-img
                :src="assetPreviews.signature2"
                contain
                max-height="300"
                max-width="319"
            ></v-img>
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>
          <div class="w-full px-3 mb-6">
            <div class="cpd-provider-form__map-header">
              <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              >Location on Map</label>
              <v-btn
                  class="cpd-provider-form__map-toggle"
                  text
                  small
                  type="button"
                  @click="toggleMapSize"
              >
                <v-icon left small>{{ mapExpanded ? "mdi-arrow-collapse" : "mdi-arrow-expand" }}</v-icon>
                {{ mapExpanded ? "Minimize map" : "Expand map" }}
              </v-btn>
            </div>
            <div class="cpd-provider-form__map-controls">
              <div class="cpd-provider-form__map-field">
                <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >Latitude</label>
                <input
                    id="latitude"
                    v-model="formValues.latitude"
                    :disabled="disable"
                    readonly
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    name
                    placeholder="eg-7.00000"
                    type="number"
                />
              </div>
              <div class="cpd-provider-form__map-field">
                <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                >Longtiude</label>
                <input
                    id="longtiude"
                    v-model="formValues.longtiude"
                    :disabled="disable"
                    readonly
                    class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    name
                    placeholder="eg-8.00000"
                    type="number"
                />
              </div>
            </div>
            <div class="cpd-provider-form__map-shell" :class="{ 'is-expanded': mapExpanded }">
              <div ref="trainingCenterMap" class="cpd-provider-form__map"></div>
            </div>
            <div class="cpd-provider-form__map-hint">
              Click on the map to set latitude and longitude (Ethiopia only).
            </div>
          </div>
          <!--          <div class="w-full md:w-1/3 px-3 mb-6 md:mb-0">-->
          <!--            <label-->
          <!--              class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"-->
          <!--              >CPD Provider's Signature 3</label-->
          <!--            >-->
          <!--              <v-file-input-->
          <!--                show-size-->
          <!--                counter-->
          <!--                v-model="signature3Image"-->
          <!--                label="File input signature 3"-->
          <!--                name="signature3Image"-->
          <!--              ></v-file-input>-->
          <!--              -->
          <!--            <v-img-->
          <!--              contain-->
          <!--              max-height="300"-->
          <!--              max-width="319"-->
          <!--              :src="formValues.signature3_url"-->
          <!--            ></v-img>-->
          <!--          </div>-->
        </div>

        <div class="flex flex-wrap cpd-provider-form__actions">
          <div class="w-full">
            <button
                class="cpd-provider-form__submit"
                type="button"
                @click="showConfirmation(formValues.editMode)"
            >
              {{
              formValues.editMode ? "Update CPD Provider" : "Add CPD Provider"
              }}
            </button>
          </div>
          <div class="md:w-2/3"></div>
        </div>
      </v-card>
      <confirmationModal
          v-if="confirmation"
          @confirmed="submit"
          :title="title"
          @close="confirmation = false"
          @openDialog="true"
      >
      </confirmationModal>
    </div>
  </ValidationObserver>
</template>

<script>
import "../../plugins/leaflet/leaflet.css";
import * as L from "leaflet";
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
import {isValidEthiopianPhone, normalizeEthiopianPhone} from "@/utils/phone";
import {required, min_value, email, regex, image, ext} from "vee-validate/dist/rules";
import ethiopic from "ethiopic-calendar";
import {
  getRegionList,
  getZoneByRegionId,
  getWoredaByZoneId, getUser,
} from "./../../utils/helper";
import {AccreditorService} from "../Accreditors/accreditor.service";
import confirmationModal from "../../common/confirmation-modal.vue"
import {TrainerService} from "../Trainers/trainers.service";
import {buildPreviewUrl, openPresignedUrl} from "@/utils/file";

const ETHIOPIA_GEOJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      id: "ETH",
      properties: {
        name: "Ethiopia",
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [37.90607, 14.95943],
            [38.51295, 14.50547],
            [39.0994, 14.74064],
            [39.34061, 14.53155],
            [40.02625, 14.51959],
            [40.8966, 14.11864],
            [41.1552, 13.77333],
            [41.59856, 13.45209],
            [42.00975, 12.86582],
            [42.35156, 12.54223],
            [42, 12.1],
            [41.66176, 11.6312],
            [41.73959, 11.35511],
            [41.75557, 11.05091],
            [42.31414, 11.0342],
            [42.55493, 11.10511],
            [42.776852, 10.926879],
            [42.55876, 10.57258],
            [42.92812, 10.02194],
            [43.29699, 9.54048],
            [43.67875, 9.18358],
            [46.94834, 7.99688],
            [47.78942, 8.003],
            [44.9636, 5.00162],
            [43.66087, 4.95755],
            [42.76967, 4.25259],
            [42.12861, 4.23413],
            [41.855083, 3.918912],
            [41.1718, 3.91909],
            [40.76848, 4.25702],
            [39.85494, 3.83879],
            [39.559384, 3.42206],
            [38.89251, 3.50074],
            [38.67114, 3.61607],
            [38.43697, 3.58851],
            [38.120915, 3.598605],
            [36.855093, 4.447864],
            [36.159079, 4.447864],
            [35.817448, 4.776966],
            [35.817448, 5.338232],
            [35.298007, 5.506],
            [34.70702, 6.59422],
            [34.25032, 6.82607],
            [34.0751, 7.22595],
            [33.56829, 7.71334],
            [32.95418, 7.78497],
            [33.2948, 8.35458],
            [33.8255, 8.37916],
            [33.97498, 8.68456],
            [33.96162, 9.58358],
            [34.25745, 10.63009],
            [34.73115, 10.91017],
            [34.83163, 11.31896],
            [35.26049, 12.08286],
            [35.86363, 12.57828],
            [36.27022, 13.56333],
            [36.42951, 14.42211],
            [37.59377, 14.2131],
            [37.90607, 14.95943],
          ],
        ],
      },
    },
  ],
};

const ETHIOPIA_POLYGON = ETHIOPIA_GEOJSON.features[0].geometry.coordinates[0];

const isPointInPolygon = (lat, lng, polygon) => {
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];
    const intersect =
        (yi > lat) !== (yj > lat) &&
        lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
};

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Invalid Value",
});
extend("regex", {
  ...regex,
  message: "Name should contain only letters",
});
extend("phone_regex", {
  ...regex,
  message: "Use +251 then 9 or 7 and 8 digits (e.g. +2519xxxxxxx).",
});
extend("institution_phone_regex", {
  message: "Use +251 followed by 9 digits (e.g. +2511xxxxxxx or +2519xxxxxxx).",
  validate: (value) =>
      !value ||
      isValidEthiopianPhone(value, {allowedStartingDigits: null}),
});

extend("email", {
  ...email,
  message: "Email must be valid",
});
extend("image", {
  ...ext,
  message: "Only image files are allowed.",
  validate: (file) => file && file.type.startsWith("image/")
});
extend("max_size", {
  message: "File size must be less than 2MB.",
  validate: (file, [size]) => file && file.size <= size * 1024
});
export default {
  computed: {
    image() {
      return image
    }
  },
  props: {
    trainingCenter: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    confirmationModal,
  },
  data() {
    return {
      formValues: {
        trainingCenterName: "",
        geolocation: "",
        latitude: "",
        longtiude: "",
        cpdProvides: "",
        cpdProviderOwnership: "Public",
        coordinatorName: "",
        institutionPhoneNumber: "",
        institutionEmailAddress: "",
        coordinatorEmailAddress: "",
        coordinatorPhoneNumber: "",
        pobox: "",
        accreditedById: null,
        expertLevelId: null,
        woreda_id: null,
        zone_id: null,
        region_id: null,
        isActive: true,
        accreditationDate: null,
        editMode: false,
      },
      checklist: null,
      logoImage: null,
      stampImage: null,
      signature1Image: null,
      signature2Image: null,
      signature3Image: null,
      showProgress: false,
      ACCREDITED_BY: [],
      REGIONS: [],
      defaultRegion: null,
      FILTERED_ZONES: [],
      FILTERED_WOREDAS: [],
      defaultZone: null,
      date: new Date().toISOString().substr(0, 10),
      etDate: null,
      startMenu: false,
      clearable: true,
      searchable: true,
      regionLoading: false,
      zoneLoading: false,
      woredaLoading: false,
      accreditorsLoading: false,

      disable: false,
      confirmation: false,
      title:'',
      map: null,
      mapMarker: null,
      mapExpanded: false,
      ethiopiaBounds: null,
      assetPreviews: {
        checklist: null,
        logo: null,
        stamp: null,
        signature1: null,
        signature2: null,
      },
      assetObjectUrls: {
        logo: null,
        stamp: null,
        signature1: null,
        signature2: null,
      },
      checklistPreviewUrl: null,
      checklistExistingUrl: null,
      checklistObjectUrl: null,
    };
  },
  async beforeMount() {
    const user = getUser();
    this.formValues.accreditedById = this.formValues.accreditedById ?? user.data?.['accreditorId'];

    this.regionLoading = true;
    this.accreditorsLoading = true;
    const res = await AccreditorService.getAllAccreditorsList();
    if (res.status === 200) {
      this.ACCREDITED_BY = res.data.rows;
    } else {
      this.$toast.error(
          "There was a problem fetching Accreditors, Please try Again!"
      );
    }
    this.accreditorsLoading = false;
    this.REGIONS = await getRegionList();
    this.regionLoading = false;
  },
  created() {
    const date = new Date().toISOString().substr(0, 10);
    this.etDate = this.convertGE(date);
    if (this.trainingCenter != null) {
      this.formValues = this.trainingCenter;
      this.formValues.editMode = true;
      this.formValues.cpdProviderOwnership =
          this.formValues.cpdProviderOwnership || "Public";
      this.formValues.region_id
          ? this.regionOnChange(this.formValues.region_id)
          : "";
      this.formValues.zone_id ? this.zoneOnChange(this.formValues.zone_id) : "";
      this.disable = this.trainingCenter.id == getUser().data?.['cpdProviderId'];
      this.prefetchAssetPreviews();
    }
    this.formValues.coordinatorPhoneNumber = normalizeEthiopianPhone(
        this.formValues.coordinatorPhoneNumber,
        {forcePrefix: true}
    );
    this.formValues.institutionPhoneNumber = normalizeEthiopianPhone(
        this.formValues.institutionPhoneNumber,
        {forcePrefix: false, allowedStartingDigits: null}
    );

  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    if (this.checklistObjectUrl) {
      URL.revokeObjectURL(this.checklistObjectUrl);
      this.checklistObjectUrl = null;
    }
    this.revokeAllAssetObjectUrls();
  },
  methods: {
    onPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {forcePrefix});
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    onInstitutionPhoneInput(field, value, forcePrefix = false) {
      const normalized = normalizeEthiopianPhone(value, {
        forcePrefix,
        allowedStartingDigits: null,
      });
      if (normalized !== this.formValues[field]) {
        this.formValues[field] = normalized;
      }
    },
    isDocumentPath(path) {
      if (!path || typeof path !== "string") return false;
      const cleanPath = path.split("?")[0];
      const ext = cleanPath.split(".").pop()?.toLowerCase();
      return ["pdf", "doc", "docx"].includes(ext);
    },
    async buildAssetPreview(path) {
      const isDocument = this.isDocumentPath(path);
      return buildPreviewUrl(path, {
        preferHttps: false,
        allowInsecure: true,
        toast: this.$toast,
        fetchImage: isDocument ? null : (url) => TrainerService.getImage({url}),
      });
    },
    getAssetPathKey(key) {
      return {
        logo: "logo_url",
        stamp: "stamp_url",
        signature1: "signature1_url",
        signature2: "signature2_url",
      }[key];
    },
    revokeAssetObjectUrl(key) {
      if (this.assetObjectUrls[key]) {
        URL.revokeObjectURL(this.assetObjectUrls[key]);
        this.assetObjectUrls[key] = null;
      }
    },
    revokeAllAssetObjectUrls() {
      Object.keys(this.assetObjectUrls).forEach((key) => {
        this.revokeAssetObjectUrl(key);
      });
    },
    async restoreExistingAssetPreview(key) {
      const pathKey = this.getAssetPathKey(key);
      const path = pathKey ? this.formValues?.[pathKey] : null;
      if (!path) {
        this.$set(this.assetPreviews, key, null);
        return;
      }
      const url = await this.buildAssetPreview(path);
      this.$set(this.assetPreviews, key, url || null);
    },
    async handleAssetChange(file, key) {
      const nextFile = Array.isArray(file) ? file[0] : file;
      this.revokeAssetObjectUrl(key);

      if (nextFile) {
        const objectUrl = URL.createObjectURL(nextFile);
        this.assetObjectUrls[key] = objectUrl;
        this.$set(this.assetPreviews, key, objectUrl);
        return;
      }

      await this.restoreExistingAssetPreview(key);
    },
    async prefetchAssetPreviews() {
      const assets = [
        {path: this.formValues.checklist, key: "checklist"},
        {path: this.formValues.logo_url, key: "logo"},
        {path: this.formValues.stamp_url, key: "stamp"},
        {path: this.formValues.signature1_url, key: "signature1"},
        {path: this.formValues.signature2_url, key: "signature2"},
      ];
      await Promise.all(
          assets.map(async (asset) => {
            if (!asset.path) return;
            const url = await this.buildAssetPreview(asset.path);
            if (url) {
              this.$set(this.assetPreviews, asset.key, url);
              if (asset.key === "checklist") {
                this.checklistExistingUrl = url;
                if (!this.checklist) {
                  this.checklistPreviewUrl = url;
                }
              }
            }
          })
      );
    },
    handleChecklistChange(file) {
      const nextFile = Array.isArray(file) ? file[0] : file;
      if (this.checklistObjectUrl) {
        URL.revokeObjectURL(this.checklistObjectUrl);
        this.checklistObjectUrl = null;
      }
      if (nextFile) {
        this.checklistObjectUrl = URL.createObjectURL(nextFile);
        this.checklistPreviewUrl = this.checklistObjectUrl;
      } else {
        this.checklistPreviewUrl = this.checklistExistingUrl;
      }
    },
    async openChecklistPreview() {
      if (this.checklistObjectUrl) {
        window.open(this.checklistObjectUrl, "_blank");
        return;
      }
      const path = this.formValues?.checklist;
      if (path) {
        await openPresignedUrl(path, {preferHttps: false, allowInsecure: true, toast: this.$toast});
      }
    },
    async showConfirmation(editMode) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      if (!this.isEthiopiaSelectionValid()) {
        this.$toast.error("Please select a location within Ethiopia.");
        return;
      }

      this.confirmation = true;
      this.title = editMode? "Update CPD Provider" : "Add CPD Provider";
    },

    async regionOnChange(event) {
      this.zoneLoading = true;
      this.FILTERED_ZONES = [];
      this.FILTERED_WOREDAS = [];
      const regionId = event;
      event ? (this.FILTERED_ZONES = await getZoneByRegionId(regionId)) : null;
      this.zoneLoading = false;
    },
    async zoneOnChange(event) {
      this.woredaLoading = true;
      const zoneId = event;
      event ? (this.FILTERED_WOREDAS = await getWoredaByZoneId(zoneId)) : null;
      this.woredaLoading = false;
    },
    initMap() {
      if (!this.$refs.trainingCenterMap) return;
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
      const ethiopiaLayer = L.geoJSON(ETHIOPIA_GEOJSON, {interactive: false});
      const ethiopiaBounds = ethiopiaLayer.getBounds();
      this.ethiopiaBounds = ethiopiaBounds;
      const map = L.map(this.$refs.trainingCenterMap, {
        attributionControl: false,
        maxBounds: ethiopiaBounds,
        maxBoundsViscosity: 1.0,
      });

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {}).addTo(map);
      ethiopiaLayer.addTo(map);

      const minZoom = map.getBoundsZoom(ethiopiaBounds);
      map.setMinZoom(minZoom);
      map.fitBounds(ethiopiaBounds, {padding: [12, 12]});
      this.map = map;

      const existingLat = Number(this.formValues.latitude);
      const existingLng = Number(this.formValues.longtiude);
      if (Number.isFinite(existingLat) && Number.isFinite(existingLng)) {
        this.setMapMarker(existingLat, existingLng);
      }

      map.on("click", (event) => {
        const {lat, lng} = event.latlng;
        if (!isPointInPolygon(lat, lng, ETHIOPIA_POLYGON)) {
          return;
        }
        this.formValues.latitude = lat.toFixed(6);
        this.formValues.longtiude = lng.toFixed(6);
        this.setMapMarker(lat, lng);
      });
    },
    toggleMapSize() {
      this.mapExpanded = !this.mapExpanded;
      this.$nextTick(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });
    },
    setMapMarker(lat, lng) {
      if (!this.map) return;
      const latLng = L.latLng(lat, lng);
      if (!this.mapMarker) {
        this.mapMarker = L.circleMarker(latLng, {
          radius: 8,
          color: "#1976d2",
          fillColor: "#1976d2",
          fillOpacity: 0.75,
        }).addTo(this.map);
      } else {
        this.mapMarker.setLatLng(latLng);
      }
      this.map.panTo(latLng);
    },
    isEthiopiaSelectionValid() {
      const lat = Number(this.formValues.latitude);
      const lng = Number(this.formValues.longtiude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return true;
      }
      return isPointInPolygon(lat, lng, ETHIOPIA_POLYGON);
    },
    async submit() {
      // if (!(await this.$refs.observer.validate())) return;
      // this.$refs.observer.validate();
      let formData = new FormData();
      for (const key in this.formValues) {
        formData.append(key, this.formValues[key]);
      }

      if (this.checklist) {
        formData.append("checklist", this.checklist);
      }

      if (this.logoImage) {
        formData.append("image", this.logoImage);
      }

      if (this.stampImage) {
        formData.append("stampImage", this.stampImage)
      }

      if (this.signature1Image) {
        formData.append("signature1Image", this.signature1Image)
      }

      if (this.signature2Image) {
        formData.append("signature2Image", this.signature2Image)
      }

      if (this.signature3Image) {
        formData.append("signature3Image", this.signature3Image)
      }

      this.$emit("registerOrUpdateTrainingCenter", formData);
      this.$emit("close");
    },
    convertGE(val) {
      if (!val) return val;
      const [year, month, day] = val.split("-").map(Number);
      if (this.pickerType === "year") {
        let etDate = ethiopic.ge(year, month || 6, day || 1); // so it will be the same year in both directions
        return etDate.year.toString().padStart(4, "0");
      } else {
        let etDate = ethiopic.ge(year, month || 1, day || 1);
        return (
            etDate.year.toString().padStart(4, "0") +
            "-" +
            etDate.month.toString().padStart(2, "0") +
            "-" +
            etDate.day.toString().padStart(2, "0")
        );
      }
    },
  },
};
</script>

<style scoped>
.cpd-provider-form__shell {
  padding: 12px;
}

.cpd-provider-form__grid {
  margin: 12px 16px 6px;
  row-gap: 12px;
}

.cpd-provider-form__grid > div {
  margin-bottom: 0 !important;
}

.cpd-provider-form__grid br {
  display: none;
}

.cpd-provider-form__actions {
  margin: 8px 16px 16px;
  justify-content: flex-end;
}

.cpd-provider-form__actions .w-full {
  display: flex;
  justify-content: flex-end;
}

.cpd-provider-form__submit {
  background: #1976d2;
  border: 1px solid #1976d2;
  color: #ffffff;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 6px;
}

.cpd-provider-form__submit:hover {
  background: #1565c0;
  border-color: #1565c0;
}

.cpd-provider-form__radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cpd-provider-form__radio {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1f2937;
}

.cpd-provider-form__map-shell {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
}

.cpd-provider-form__map {
  height: 260px;
  width: 100%;
}

.cpd-provider-form__map-shell.is-expanded .cpd-provider-form__map {
  height: 70vh;
}

.cpd-provider-form__map-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.cpd-provider-form__map-header label {
  margin-bottom: 0;
}

.cpd-provider-form__map-controls {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.cpd-provider-form__map-field {
  min-width: 0;
}

.cpd-provider-form__map-toggle {
  color: #1976d2 !important;
  text-transform: none;
  font-weight: 600;
}

.cpd-provider-form__map-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #475569;
}

.cpd-provider-form__preview {
  margin-top: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px;
  background: #f8fafc;
}

.cpd-provider-form__preview-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.cpd-provider-form__preview-frame {
  width: 100%;
  min-height: 240px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
}

.cpd-provider-form__download .v-icon {
  color: #1976d2 !important;
}

.cpd-provider-form__download {
  color: #1976d2 !important;
  font-weight: 600;
  text-transform: none;
}

@media (max-width: 700px) {
  .cpd-provider-form__map-controls {
    grid-template-columns: 1fr;
  }
}

.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}
</style>
